var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3987 10.1088L17.9506 9.39544C18.1382 9.32035 18.2883 9.17017 18.2883 8.9449C18.2883 8.71962 18.1382 8.56944 17.9506 8.49434L15.3987 7.78098C13.0344 7.10515 11.233 5.30295 10.5575 2.97511L9.8445 0.421997C9.73192 0.00899266 9.05641 0.00899266 8.94383 0.421997L8.23079 2.97511C7.55529 5.3405 5.75394 7.1427 3.38967 7.78098L0.837753 8.49434C0.650113 8.56944 0.5 8.71962 0.5 8.9449C0.5 9.17017 0.650113 9.32035 0.837753 9.39544L3.38967 10.1088C5.75394 10.7846 7.55529 12.5868 8.23079 14.9147L8.94383 17.4678C9.01888 17.6555 9.169 17.8057 9.39417 17.8057C9.61933 17.8057 9.76945 17.6555 9.8445 17.4678L10.5575 14.9147C11.233 12.5493 13.0344 10.7471 15.3987 10.1088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.44bed7062ca8f5907187d5994bf8cf69.svg";
export { ForwardRef as ReactComponent };